import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTicketAlt } from '@fortawesome/free-solid-svg-icons'
import Flex from '../../common/Flex'
import { formatNumber } from '../rewardsUtils'

// El sorteo en sí (fecha, premios, ganadores) es HO-TASK-273, que pasó al
// backlog: por ahora la API solo expone los tickets ganados este mes, que
// otorgan los aceleradores y los referidos premiados.
const RaffleCard = ({ tickets }) => {
  const count = Number(tickets) || 0

  return (
    <Card className="h-100">
      <CardBody>
        <Flex align="center">
          <div
            className="d-flex flex-center rounded-circle mr-3 flex-shrink-0 bg-soft-info text-info"
            style={{ width: '3rem', height: '3rem' }}
          >
            <FontAwesomeIcon icon={faTicketAlt} className="fs-2" />
          </div>
          <div className="flex-grow-1">
            <h6 className="text-600 mb-1">Tickets del sorteo este mes</h6>
            <h4 className="mb-0">
              {formatNumber(count)} {count === 1 ? 'ticket' : 'tickets'}
            </h4>
          </div>
        </Flex>
        <p className="fs--1 mb-0 mt-3 text-600">
          {count > 0
            ? 'Ya tienes tickets para el sorteo mensual. Te avisaremos cuando se anuncie la fecha.'
            : 'Gana tickets para el sorteo mensual usando los aceleradores de puntos o invitando a tus vecinos.'}
        </p>
      </CardBody>
    </Card>
  )
}

RaffleCard.propTypes = { tickets: PropTypes.number }

export default RaffleCard
